import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Skeleton } from "@/components/ui/skeleton";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";

export default function AuditTrail() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/audit?page_size=100").then((r) => setData(r.data)).catch(() => {}); }, []);

  return (
    <div className="space-y-6">
      <div>
        <p className="uppercase text-[10px] tracking-wider font-semibold text-muted-foreground">Keamanan & Kepatuhan</p>
        <h1 className="font-heading text-3xl font-bold tracking-tight">Audit Trail</h1>
        <p className="text-sm text-muted-foreground mt-1">Catatan lengkap aktivitas sistem.</p>
      </div>
      <Card className="overflow-hidden">
        <div className="overflow-x-auto scrollbar-thin">
          <Table>
            <TableHeader><TableRow className="bg-muted/50">
              <TableHead>Waktu</TableHead><TableHead>Pengguna</TableHead><TableHead>Role</TableHead>
              <TableHead>Aksi</TableHead><TableHead>Detail</TableHead>
            </TableRow></TableHeader>
            <TableBody>
              {!data ? (
                <TableRow><TableCell colSpan={5}><Skeleton className="h-8 w-full" /></TableCell></TableRow>
              ) : data.items.length === 0 ? (
                <TableRow><TableCell colSpan={5} className="text-center text-muted-foreground py-10">Belum ada catatan.</TableCell></TableRow>
              ) : data.items.map((l) => (
                <TableRow key={l.id}>
                  <TableCell className="text-xs tabular-nums whitespace-nowrap">{new Date(l.timestamp).toLocaleString("id-ID")}</TableCell>
                  <TableCell className="text-sm font-medium">{l.user_name || "-"}</TableCell>
                  <TableCell className="text-xs text-muted-foreground">{l.role}</TableCell>
                  <TableCell><Badge variant="outline" className="font-mono text-[10px]">{l.action}</Badge></TableCell>
                  <TableCell className="text-xs text-muted-foreground max-w-md truncate">{l.new_value ? JSON.stringify(l.new_value) : ""}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </Card>
    </div>
  );
}
